// extracted by mini-css-extract-plugin
module.exports = {"Table":"styles_Table__3MAfk","tab-container":"styles_tab-container__c6sYV","tab":"styles_tab__2JUqT","selected":"styles_selected__16A8G"};